export default {
    Отвращение: "disgust",
    Удивление: "surprize",
    Страх: "fear",
    Печаль: "sadness",
    Интерес: "interest",
    Радость: "joy",
    Доверие: "trust",
}